import { getAll } from '@/api/tiers';
import store from '@/store/store';

export default async function getTiers(tiers) {
  const tiersFiltered = [...new Set(tiers)];
  if (tiersFiltered.length === 0) return [];

  const tiersApi = (await getAll({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      nomsCommercialOuNomsJuridique: tiersFiltered,
    },
  })).data.result.items;
  const errors = [];
  tiersFiltered.forEach((tier) => {
    const isInResult = tiersApi.find((t) => {
      return t.nomCommercial === tier;
    });
    if (!isInResult) {
      errors.push({
        message: 'importDonne.dataNotExist',
        parametres: { data: tier },
      });
    }
  });
  if (errors.length > 0) throw errors;
  return tiersApi;
}
